import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatDistanceToNow } from "date-fns";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png"; // ✅ Replace with your BYN logo path

const NotificationPage = () => {
  const [notifications, setNotifications] = useState([]);
  const userId = localStorage.getItem("customerId");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get(`http://localhost:5000/api/notifications/all/${userId}`);
        setNotifications(res.data.notifications || []);
      } catch (err) {
        console.error("❌ Error fetching notifications", err);
      }
    };

    fetchNotifications();
  }, [userId]);

  const handleNotificationClick = (notif) => {
    // ✅ Optional: mark it as read later
    navigate(notif.link);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="text-3xl font-bold text-center text-blue-700 mb-8">🔔 Your Notifications</h1>

      {notifications.length === 0 ? (
        <p className="text-center text-gray-600">No notifications yet.</p>
      ) : (
        <div className="max-w-3xl mx-auto space-y-4">
          {notifications.map((notif) => (
            <div
              key={notif._id}
              onClick={() => handleNotificationClick(notif)}
              className={`cursor-pointer flex items-center p-4 rounded-xl shadow transition ${
                notif.read ? "bg-white" : "bg-yellow-100"
              } hover:shadow-md`}
            >
              {/* BYN Logo */}
              <img src={logo} alt="BYN" className="w-12 h-12 rounded-full object-cover mr-4" />

              <div className="flex-1">
                <p className="text-gray-800 font-semibold">{notif.message}</p>
                <p className="text-sm text-gray-500">
                  {formatDistanceToNow(new Date(notif.createdAt), { addSuffix: true })}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationPage;
